import { z } from 'zod'
import { AvatarSVG, ConversationStatus, SentimentLevel } from './enums'

export const Contact = z.object({
  avatar: AvatarSVG.nullable(),
  id: z.string(),
  name: z.string(),
  color: z.string(),
  email: z.string().nullable(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date(),
  workspaceId: z.string(),
})
export type Contact = z.infer<typeof Contact>

export const AvatarType = AvatarSVG
export type AvatarType = z.infer<typeof AvatarType>

export const ContactFolderTag = z.object({
  id: z.string(),
  name: z.string(),
})
export type ContactFolderTag = z.infer<typeof ContactFolderTag>

export const ContactWithMostRecentConversationDetails = Contact.extend({
  status: ConversationStatus.nullish(),
  sentiment: SentimentLevel.nullish(),
  formName: z.string(),
  /** Distinct folders across every form this contact has filled out. */
  folders: z.array(ContactFolderTag).default([]),
})
export type ContactWithMostRecentConversationDetails = z.infer<typeof ContactWithMostRecentConversationDetails>

